import React from "react";
import { Link } from "components";
import { getLocationSubparts } from "utils";
import "./pagination.scss";
import { navigate } from "gatsby";
import { range } from "lodash";

interface PaginationProps {
  location: Location;
  numberOfPages: number;
  currentPageNumber: number;
}

export const Pagination = ({ numberOfPages, currentPageNumber, location }: PaginationProps): JSX.Element => {
  // if there is one page of posts, don't display pagination
  if (numberOfPages === 1) {
    return null;
  }
  const pageNumbers = range(1, numberOfPages + 1);

  if (pageNumbers.length === 0) return null;

  return (
    <div className="pagination">
      {pageNumbers.map((pageNum, index) => {
        const locationSubparts = getLocationSubparts(location);

        const linkToPageNumber = `${[...locationSubparts, pageNum].join("/")}/`;

        const isActive = currentPageNumber === pageNum;

        return isActive ? (
          // option if its the current page
          <span className="pagination__page-number" key={`pagination-${index}`}>
            {pageNum}
          </span>
        ) : // option if its NOT the current page (linkable)
        pageNum === 1 ? (
          <Link to={`/${locationSubparts.join("/")}/`} className="pagination__page-number" key={`pagination-${index}`}>
            {pageNum}
          </Link>
        ) : (
          <Link to={`/${linkToPageNumber}`} className="pagination__page-number" key={`pagination-${index}`}>
            {pageNum}
          </Link>
        );
      })}
    </div>
  );
};
